export const stripDataOptions = (selections) => {
	if (selections && selections.length > 0) {
		return selections.map((selection) => {
			return { label: selection.label, value: selection.value };
		});
	}

	return [];
};
